import { createStyles, Theme, emphasize } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		userAccountsRoot: {
			maxWidth: '670px',
			width: '100%',
			marginTop: '30px',
			marginBottom: '30px',
			padding: '0px 10px',
			position: 'relative',
		},
		cardRoot: {
			border: '1px solid #ebebeb',
			boxShadow: 'none',
			borderRadius: '8px',
		},
		titleSection: {
			display: 'flex',
			flexFlow: 'row',
			justifyContent: 'space-between',
		},
		title: {
			color: '#424242',
			fontSize: '18px',
			fontWeight: 500,
		},
		actionTitle: {
			cursor: 'default',
			marginLeft: 'auto',
		},
		actionTitleMargin: {
			marginRight: 15,
		},
		cardDescription: {
			display: 'flex',
			flexFlow: 'column',
			marginBottom: '20px',
			marginTop: '5px',
			color: '#929292',
		},
		cardItemWrap: {
			display: 'flex',
			flex: 1,
			flexFlow: 'row',
		},
		cardItem: {
			display: 'flex',
			flexFlow: 'row',
			flex: 1,
			alignItems: 'center',
		},
		profilePicture: {
			width: '50px',
			height: '50px',
			borderRadius: '50%',
			backgroundColor: '#e8e8e8',
			marginRight: '5px',
		},
		details: {
			alignSelf: 'center',
		},
		name: {
			color: '#424242',
			fontSize: '15px',
			fontWeight: 500,
		},
		role: {
			color: '#424242',
			fontSize: '12px',
			fontWeight: 'normal',
		},
		menuIcon: {
			marginLeft: 'auto',
		},
		moreVertButton: {
			// color: theme.palette.grey[400],
		},
		moreVertIcon: {
			color: '#1b1a7c',
		},
		moreMenu: {
			// '-webkit-box-shadow': '0px 1px 5px 0px rgba(235, 235, 235, 0.09)',
			// '-moz-box-shadow': '0px 1px 5px 0px rgba(235, 235, 235, 0.09)',
			// boxShadow: '0px 1px 5px 0px rgba(235, 235, 235, 0.09)',
			'& > ul': {
				padding: 0,
				'& > li': {
					padding: '0 16px',
					fontSize: 12,
					minHeight: 32,
					color: theme.palette.grey[700],
				},
			},
		},
		asyncSelect: {
			flexGrow: 1,
			marginTop: 8,
			marginBottom: 12,
		},
		input: {
			display: 'flex',
			padding: 0,
			height: 'auto',
			cursor: 'default',
		},
		placeholder: {
			position: 'absolute',
			left: 2,
			bottom: 6,
			fontSize: 16,
		},
		valueContainer: {
			display: 'flex',
			flexWrap: 'wrap',
			flex: 1,
			alignItems: 'center',
			overflow: 'hidden',
		},
		chip: {
			margin: theme.spacing(0.5, 0.25),
		},
		chipFocused: {
			backgroundColor: emphasize(
				theme.palette.type === 'light'
					? theme.palette.grey[300]
					: theme.palette.grey[700],
				0.08,
			),
		},
		noOptionsMessage: {
			padding: theme.spacing(1, 2),
		},
		cardItemDisabled: {
			pointerEvents: 'none',
			opacity: '0.5',
		},
		cardItemInfo: {
			marginLeft: 'auto',
			alignSelf: 'start',
			marginTop: 15,
			color: 'grey',
		},
		avatarContent: {
			display: 'flex',
			flexDirection: 'row',
		},
		rolesDescription: {
			color: 'grey',
			fontSize: 12,
			marginTop: 5,
		},
	})
